import SectionHeading from "@/components/base/SectionHeading";
import { whyChooseUs } from "@/mocks/site";

const bubbleStyles = [
  "bg-primary-100 text-primary-600",
  "bg-secondary-100 text-secondary-600",
  "bg-accent-100 text-accent-600",
];

/**
 * "Why Orthospine?" — a colourful card grid built from the practice's
 * factual differentiators.
 */
export default function WhyOrthospine() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-background-50 via-background-100/60 to-background-50 py-16 md:py-24">
      <div className="absolute -right-24 top-10 h-80 w-80 rounded-full bg-accent-100/50 blur-3xl" aria-hidden="true"></div>
      <div className="absolute -left-24 bottom-10 h-80 w-80 rounded-full bg-secondary-100/50 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Why Choose Us"
          title="Why Orthospine?"
          description="Everything we do centres on one goal — understanding your condition and choosing the care that is genuinely right for you."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {whyChooseUs.map((item, index) => (
            <article
              key={item.title}
              className="reveal group rounded-2xl border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-[0_28px_55px_-38px_rgba(15,40,80,0.55)]"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-xl transition-transform duration-300 group-hover:scale-105 ${
                  bubbleStyles[index % bubbleStyles.length]
                }`}
              >
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}